import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {Element} from 'react-scroll';
import { Tooltip } from 'react-tippy';
import Aux from '../../../components/Hoc/Aux';
import VimeoEmbed from '../../../components/VimeoEmbed/VimeoEmbed';
import medicare101Thumb from '../../../assets/video/medicare-101-thumb.jpg';
import LearnMore from '../../../components/Forms/LearnMore';
import ReasonsResults from '../../../components/Reasons/ReasonsResults';
import Testimonials from '../../../components/Testimonials/Testimonials';
import ScrollButton from '../../../components/Header/ScrollButton';
import Accordion from '../../../components/Accordion/Accordion';
import getMedicareFaqs from '../../../helpers/medicareFaqs';
// import medicareRatingSm from '../../../assets/svg/icon-medicare-rating-sm.svg';
import cdphpLogo from '../../../assets/logo.svg';

class MedicareCompare extends Component {
  componentDidMount () {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'GAEvent',
      'eventCategory': 'View',
      'eventAction': 'Landing',
      'eventLabel': 'Plans - Medicare Compare',
      'eventValue': undefined
    });
  }

  render () {
    const accordionData = getMedicareFaqs({ planType: 'hmo' });

    return (
      <Aux>
        <header className='locked landingPage'>
          {/* <div className='topBanner'>CDPHP Medicare HMO and PPO plans rated 5 stars by the Centers for Medicare &amp; Medicaid Services for 2023. Enroll any time before November 30th.</div> */}
          <div className='main'>
            <div>
              <Link to='/' className='logo'>
                <img src={cdphpLogo} alt='CDPHP | Capital District Physicians&rsquo; Health Plan' />
              </Link>
              {/* <p className='eligible'>Enroll anytime before December 7th!</p> */}
            </div>
            <div className='connect'>
              <p>
                <strong>Need help selecting the right Medicare plan?</strong>
                <span><a href='tel:888-519-7898' className='tel phoneswap'>888-519-7898</a> | TTY: 711 <em>M-F, 8 a.m. – 8 p.m.<sup>‡</sup></em></span>
              </p>
            </div>
            <ScrollButton
              text='Contact Me'
              scrollName='learnForm'
              scrollOpts={{
                duration: 800,
                delay: 0,
                smooth: 'easeInOutQuart',
                offset: -200
              }} />
          </div>
        </header>

        <article id='medicareCompare'>
          <section className='intro'>
            <div className='wrap'>
              <h1>Compare Our Most Popular<br /> Medicare Advantage Plans</h1>
            </div>
            <div className='wrap sm'>
              <div className='callout'>
                <p className='calloutContent'>Medicare Advantage plans cover more than Original Medicare, protecting you from unexpected&nbsp;costs.</p>
                <VimeoEmbed videoId='1215229413' hash='bd848bae19' title='CDPHP Medicare 101'
                  thumbnail={medicare101Thumb} popover />
              </div>
            </div>
          </section>

          <section>
            <div className='wrap sm'>
              <div className='results medicare container'>
                <div className='table'>
                  <table>
                    <thead>
                      <tr className='heading'>
                        <th className='item'>
                          <p className='note'><strong>Note:</strong> Original Medicare is required for any Medicare Advantage Plan</p>
                        </th>
                        <th>
                          <div className='card medicare'>
                            <h4>Original Medicare <span>Parts A &amp; B</span></h4>
                          </div>
                        </th>
                        <th>
                          <div className='card'>
                            <img src={cdphpLogo} alt='CDPHP | Capital District Physicians&rsquo; Health Plan' />
                            <h4>$0 Rx (HMO)</h4>
                          </div>
                        </th>
                        <th>
                          <div className='card'>
                            <img src={cdphpLogo} alt='CDPHP | Capital District Physicians&rsquo; Health Plan' />
                            <h4>Clear Rx (HMO)</h4>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className='subhead'>
                        <td className='item'>&nbsp;</td>
                        <td className='med'><h6><strong>Original Medicare</strong></h6><strong>$202<sup>.90</sup></strong><Tooltip html={(<span className='originalMedicare'>Most people pay the standard Part B monthly premium amount ($202.90 in 2026). Visit <a href='https://www.medicare.gov/basics/costs' target='_blank' rel='noopener noreferrer'>Medicare.gov</a> to learn more.</span>)} arrow='true' interactive='true'><span className='helpTip'>Estimated Monthly Cost</span></Tooltip></td>
                        <td className='hmp'><h6>CDPHP $0 Rx (HMO)</h6><strong>$0</strong> <span>Monthly Cost</span></td>
                        <td className='ppo'><h6>CDPHP Clear Rx (HMO)</h6><strong>$100</strong> <span>Monthly Cost</span></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Medical Deductible</h5></td>
                        <td className='med'><h6>Original Medicare:</h6>$283</td>
                        <td className='hmo'><h6>CDPHP $0 Rx (HMO):</h6><strong>$0</strong></td>
                        <td className='ppo'><h6>CDPHP Clear Rx (HMO):</h6><strong>$0</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Prescription Deductible</h5></td>
                        <td className='med nope'><h6>Original Medicare:</h6>No Drug Coverage</td>
                        <td className='hmo'><h6>CDPHP $0 Rx (HMO):</h6><strong>$700 tiers 2-5</strong></td>
                        <td className='ppo'><h6>CDPHP Clear Rx (HMO):</h6><strong>$500 tiers 3-5</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Annual Physicals</h5></td>
                        <td className='med nope'><h6>Original Medicare:</h6>No Coverage</td>
                        <td className='hmo'><h6>CDPHP $0 Rx (HMO):</h6><strong>$0</strong></td>
                        <td className='ppo'><h6>CDPHP Clear Rx (HMO):</h6><strong>$0</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Out of Network Coverage</h5></td>
                        <td className='med nope'><h6>Original Medicare:</h6>No Coverage</td>
                        <td className='hmo'><h6>CDPHP $0 Rx (HMO):</h6>Urgent/Emergency Only</td>
                        <td className='ppo'><h6>CDPHP Clear Rx (HMO):</h6>Urgent/Emergency Only</td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Primary Care Visits</h5></td>
                        <td className='med'><h6>Original Medicare:</h6>20% of Bill</td>
                        <td className='hmo'><h6>CDPHP $0 Rx (HMO):</h6><strong>$0</strong></td>
                        <td className='ppo'><h6>CDPHP Clear Rx (HMO):</h6><strong>$0</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Specialist Doctor Visits</h5></td>
                        <td className='med'><h6>Original Medicare:</h6>20% of Bill</td>
                        <td className='hmo'><h6>CDPHP $0 Rx (HMO):</h6><strong>$50</strong></td>
                        <td className='ppo'><h6>CDPHP Clear Rx (HMO):</h6><strong>$40</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Dental Allowance</h5></td>
                        <td className='med nope'><h6>Original Medicare:</h6>No Coverage</td>
                        <td className='hmo'><h6>CDPHP $0 Rx (HMO):</h6><strong>$400 / year</strong></td>
                        <td className='ppo'><h6>CDPHP Clear Rx (HMO):</h6><strong>$900 / year</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Prescription Drugs</h5></td>
                        <td className='med nope'><h6>Original Medicare:</h6>No Coverage</td>
                        <td className='hmo'><h6>CDPHP $0 Rx (HMO):</h6><Tooltip title='Pricing for prescription drugs is based on a variety of factors, but in general, generic and brand-name drugs that have a proven clinical advantage are typically less expensive, whereas experimental drugs, or those without a proven clinical advantage, tend to be more expensive.' arrow='true'><strong className='helpTip'>$5 - 29%</strong></Tooltip></td>
                        <td className='ppo'><h6>CDPHP Clear Rx (HMO):</h6><Tooltip title='Pricing for prescription drugs is based on a variety of factors, but in general, generic and brand-name drugs that have a proven clinical advantage are typically less expensive, whereas experimental drugs, or those without a proven clinical advantage, tend to be more expensive.' arrow='true'><strong className='helpTip'>$0 - 28%</strong></Tooltip></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Hospital Stays</h5></td>
                        <td className='med'><h6>Original Medicare:</h6><Tooltip title='With Original Medicare, you will have a $1,364 deductible for the first 60 days, $341/day from days 61-90, and $682/day for each “lifetime reserve day” after day 90 for each benefit period (up to 60 days over your lifetime) for inpatient hospitalizations. CDPHP Medicare plans protect you from potentially high, unexpected costs by instead offering a flat, predictable copay.' arrow='true'><span className='helpTip'>See Details</span></Tooltip></td>
                        <td className='hmo'><h6>CDPHP $0 Rx (HMO):</h6><strong>$460 per day,<br /> days 1-5, then $0</strong></td>
                        <td className='ppo'><h6>CDPHP Clear Rx (HMO):</h6><strong>$395 per day,<br /> days 1-6, then $0</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Outpatient Surgeries</h5></td>
                        <td className='med'><h6>Original Medicare:</h6>20% of Bill</td>
                        <td className='hmo'><h6>CDPHP $0 Rx (HMO):</h6><strong>$315-$365</strong></td>
                        <td className='ppo'><h6>CDPHP Clear Rx (HMO):</h6><strong>$275-$350</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Urgent Care</h5></td>
                        <td className='med'><h6>Original Medicare:</h6>20% of Bill</td>
                        <td className='hmo'><h6>CDPHP $0 Rx (HMO):</h6><strong>$40</strong></td>
                        <td className='ppo'><h6>CDPHP Clear Rx (HMO):</h6><strong>$50</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Worldwide Emergency Care</h5></td>
                        <td className='med nope'><h6>Original Medicare:</h6>No Coverage</td>
                        <td className='hmo'><h6>CDPHP $0 Rx (HMO):</h6><strong>$115</strong></td>
                        <td className='ppo'><h6>CDPHP Clear Rx (HMO):</h6><strong>$115</strong></td>
                      </tr>
                      <tr>
                        <td className='item'><h5>Maximum Annual<br />Out-of-Pocket Protection</h5></td>
                        <td className='med nope'><h6>Original Medicare:</h6>No Protection</td>
                        <td className='hmo'><h6>CDPHP $0 Rx (HMO):</h6><strong>$9,850</strong></td>
                        <td className='ppo'><h6>CDPHP Clear Rx (HMO):</h6><strong>$6,750</strong></td>
                      </tr>
                      {/* <tr>
                        <td className='item'><h5>Centers for Medicare &amp; Medicaid Services Rating<sup>†</sup></h5></td>
                        <td className='med'><h6>Original Medicare:</h6>N/A</td>
                        <td className='hmo'><h6>CDPHP $0 Rx (HMO):</h6><img src={medicareRatingSm} alt='4.5 out of 5 Medicare Ranking' /></td>
                        <td className='ppo'><h6>CDPHP Clear Rx (HMO):</h6><img src={medicareRatingSm} alt='4.5 out of 5 Medicare Ranking' /></td>
                      </tr> */}
                    </tbody></table>
                  <p className='medicare-desc'>*Your cost share (copays and coinsurances) may be different for Out-of-Network services.</p>
                </div>
              </div>
            </div>
          </section>

          <Element name='learnForm'>
            <LearnMore
              area='MedicareQuote'
              MedicareCompare='true'
              phone='888-519-7898 | TTY: 711' />
          </Element>

          <section className='compare-expenses'>
            <div className='wrap sm'>
              <div className='container'>
                <div className='navigate expenses medicare-expenses'>
                  <h4>Looking for other Medicare plan options? </h4>
                  <p><a href='/pdf/CDPHP_2027_Medicare_Individual_Options_Brochure.pdf' target='_blank' rel='noopener noreferrer'>Explore all our plans</a> or <a href='https://cdphpmedicare1.destinationrx.com/PC/2027/Shopping/Home?AgentID=cdphp-funnel' target='_blank' rel='noopener noreferrer'>enroll online</a> if you&rsquo;re ready.</p>
                </div>
              </div>
            </div>
          </section>

          <ReasonsResults intro="More Reasons Why You'll Love Us" type='medicare' />
          <Testimonials heading='&ldquo;CDPHP treats you like someone they know and care about.&rdquo;' slides='medicare' />

          <section id='faq'>
            <div className='wrap sm'>
              <h2>Frequently Asked Questions</h2>
              {accordionData.map(({ index, title, content }) => (
                <Accordion
                  key={index}
                  id={'faq' + index}
                  title={title}
                  content={content} />
              ))}
            </div>
          </section>
        </article>
      </Aux>
    );
  }
}

export default MedicareCompare;